export const environment = {
  firebase: {
    projectId: 'kiwiwrite-17310',
    appId: '1:600370947200:web:328a0bc37eab6707ab3265',
    storageBucket: 'kiwiwrite-17310.appspot.com',
    apiKey: 'AIzaSyD6GSyXW4rMiP4P0WRUgjJVidRGxmnJrk8',
    authDomain: 'kiwiwrite-17310.firebaseapp.com',
    messagingSenderId: '600370947200',
    measurementId: 'G-CYS9NKMXSM',
  },
  google: {
    client_id: '600370947200-bipl581bo5f4eot5a25uecsqla0q2gae.apps.googleusercontent.com',
  },
  nycdoe: {
    issuer: 'https://idpstgcloud.nycenet.edu/oauth2',
    client_id: 'e07e7bea-e551-4b90-8d4a-6a77643821d7',
    client_secret: 'iP98JJ2R4h',
    redirect_uri: 'https://dev.kiwiwrite.com/nyc/callback',
  },
  Azure: {
    clientapp: {
      auth: {
        clientId: 'bf5726fc-5f99-4649-84c9-9cc81b27c3a8',
        redirectUri: 'https://dev.kiwiwrite.com',
      },
      cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
      },
    },
    GetProfile: 'https://graph.microsoft.com/v1.0/me',
  },
  production: false,
  serviceWorkerEnabled: false,
  baseApiURL: 'https://api-dev.kiwiwrite.com',
  appVersion: '3.58',
  baseUrl: 'https://dev.kiwiwrite.com',
  secure: true,
  envName: 'dev',
};
